import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Search from "../../../components/search";
import Nothing from "../../../components/nothing";
import { getBestAnchorGivenScrollLocation } from '../utils/scroll';
import utils from '../../../utils';
import s from './index.less';
import Message from "../../../components/message";
import request from '../../../service/request';
// import { CUSTOMER_FOCUS_POST, CUSTOMER_CANCELFOCUS_POST } from '../../../service/api';
function Detail (props) {
    useStyles(s);

    const houseId = props.pagedata.id;
    const pageCode = props.pagedata.pageCode || 0;
    const [navList, setNavList] = useState({
        list: [
            { id: 'tab1', title: '保租房情况' },
            { id: 'tab2', title: '保租房' }
        ],
        selectIndex: 'tab1',
        show: false
    });

    const [houseInfo, setHouseInfo] = useState(props.pagedata.houseInfo || {});
    const [typeData, setTypeData] = useState(props.pagedata.typeData || {});

    const [messageInfo, setMessageInfo] = useState({
        visible: false,
        txt: ''
    });
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    }, []);

    const handleScroll = () => {// 滚动呈现
        const bestAnchorId = getBestAnchorGivenScrollLocation(navList.list, -20);
        if (bestAnchorId && navList.selectIndex !== bestAnchorId) {
            setNavList({
                ...navList,
                show: true,
                selectIndex: bestAnchorId
            });
        } else {
            setNavList({
                ...navList,
                selectIndex: 'tab1',
                show: window.pageYOffset >= 800
            });
        }
    };

    const scrollToAnchor = (anchorName) => {// 锚点
        if (anchorName) {
            const anchorElement = document.getElementById(anchorName);// 找到锚点
            if (anchorElement) { anchorElement.scrollIntoView({ block: 'start', behavior: 'auto' }); }// 如果对应id的锚点存在，就跳转到锚点
        }
    };

    const imgError = (e, type) => {
        e.target.onerror = null;
        e.target.src = require(`../../../images/common/${type ? "agent-default.jpg" : "default-img.png"}`);
    };

    const [typeDataSelectIndex, setTypeDataSelectIndex] = useState(0);
    const focusHouse = () => {
        if (props.userInfo) {
            // request.POST({
            //     url: [CUSTOMER_FOCUS_POST, CUSTOMER_CANCELFOCUS_POST][houseInfo.isFocus ? 1 : 0],
            //     params: {
            //         houseType: 3,
            //         houseId
            //     }
            // }).then(() => {
            //     setHouseInfo({
            //         ...houseInfo,
            //         isFocus: !houseInfo.isFocus
            //     });
            //     setMessageInfo({
            //         visible: true,
            //         txt: houseInfo.isFocus ? '房源取关成功' : '房源关注成功'
            //     });
            // }).catch((error) => {
            //     console.log(error, 'error');
            // });
        } else {
            const loginDiv = document.getElementsByClassName('mine-follow')[0];
            loginDiv.click();
        }
    }

    const closeMessage = () => {
        setMessageInfo({
            visible: false,
            txt: ''
        });
    };
    const shareTemplte = () => {
        return (
            typeof document !== 'undefined' ?
                <div className="page-share" onClick={focusHouse}>
                    <div className='button'>
                        {props.userInfo && houseInfo.isFocus ?
                            <><i className="iconfont icon-share">&#xe7a7;</i><font className="hover-hide">已关注</font><font className="hover-show">取消关注</font></>
                            :
                            <><i className="iconfont icon-share">&#xe7aa;</i>关注</>}
                    </div>
                    <div className='button' style={{ marginLeft: '18px' }}>
                        <img src={require("../../../images/common/share.png")} />
                        分享
                    </div>
                </div>
                : null
        )
    };
    return (
        <>{pageCode === 0 ? (Object.keys(houseInfo).length > 0 ?
            <>
                <div className="page-detail">
                    <Search
                        businesstype={4}
                        isdetail
                        housename={houseInfo.estateName}
                        houseid={houseId}
                        hideSearch={true} />
                    <div className="view-box clear">
                        <div className="header-title detail-head">
                            <div className='detail-head-right'>
                                <h1>{houseInfo.estateName}</h1>
                            </div>
                            <p>
                                {houseInfo.decorateProgress ? <span key={houseInfo.decorateProgress}>{houseInfo.decorateProgress}</span> : null}
                                {houseInfo.existingHouse ? <span key={houseInfo.existingHouse}>{houseInfo.existingHouse}</span> : null}
                            </p>
                            {/* {shareTemplte()} */}
                        </div>
                        {houseInfo.estateHeaderUrl ? <img style={{ width: '720px', marginTop: '28px' }} onError={(e) => imgError(e)} src={houseInfo.estateHeaderUrl ? `${houseInfo.estateHeaderUrl}?x-oss-process=style/acommon` : require("../../../images/common/detail-default.png")} /> : null}
                        <div className="detail-content">
                            <div className="header-price price">
                                <span className="total">{utils.numberComparison(houseInfo.minPrice, houseInfo.maxPrice, '-', '', '')}</span>
                                <span className="unit">元/月</span>
                            </div>
                            <div className="estate">
                                <div>
                                    <p><span>楼栋总数</span>{houseInfo.buildingNumber + '幢' || '暂无数据'}</p>
                                    <p><span>房屋总数</span>{houseInfo.houseNumber + '户' || '暂无数据'}</p>
                                </div>
                                <div>
                                    <p><span>容积率</span>{houseInfo.plotRatio + '%' || '暂无数据'}</p>
                                    <p><span>绿化率</span>{houseInfo.greeningRate + '%' || '暂无数据'}</p>
                                </div>
                                <div>
                                    <p><span>停车位</span>{houseInfo.parkingRatio || '暂无数据'}</p>
                                    <p><span>建筑面积</span>{houseInfo.architectureArea + 'm²' || '暂无数据'}</p>
                                </div>
                                <div>
                                    <p><span>竣工时间</span>{houseInfo.completionYearsF || '暂无数据'}</p>
                                    <p><span>建筑类型</span>{houseInfo.buildingType || '暂无数据'}</p>
                                </div>
                                <div>
                                    <p style={{ width: '100%' }}><span>地址</span>{houseInfo.address ? <>{houseInfo.address}</> : '暂无数据'}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ height: '92px', display: navList.show ? 'block' : 'none' }} />
                    <div className={navList.show ? "tab-box fixed" : 'tab-box'}>
                        <div className="list">
                            <ul className='detail-head-right'>
                                <div>
                                    {navList.list.map((items, index) => {
                                        return <li key={index} className={navList.selectIndex === items.id ? "active" : ''} onClick={() => scrollToAnchor(`tab${index + 1}`)}>{items.title}</li>
                                    })}
                                </div>
                                {/* {navList.show ? shareTemplte() : null} */}
                            </ul>
                        </div>
                    </div>
                    <div className={navList.show ? "detail-title-price-box fixed" : 'detail-title-price-box'}>
                        <div className="box">
                            <div className="header-title">
                                <h1>{houseInfo.estateName}</h1>
                            </div>
                            <div className="header-price">
                                <span className="total">{utils.numberComparison(houseInfo.minPrice, houseInfo.maxPrice, '-', '', '')}</span>
                                <span className="unit">元/月</span>
                            </div>
                        </div>
                    </div>

                    <div className="main-box">
                        <div id='tab1' className="base-content base">
                            <h2>保租房情况</h2>
                            {
                                houseInfo.estateBrief ? <div className='content-box'>
                                    <img className='bg-top' src="https://static.hsdcyf.com/hs/img/1725600100542.png" />
                                    <div className='top-title'>
                                        <img className='icon-top' src="https://static.hsdcyf.com/hs/img/1725600094793.png" />
                                        <div className='txt-top'>保障房情况</div>
                                    </div>
                                    <div className='txt-content'>{houseInfo.estateBrief}</div>
                                </div> : <Nothing pagetype={pageCode} />
                            }
                        </div>
                        <div id='tab2' className="base-content animation-list img-list">
                            <div className="tab-title">
                                <h2>保租房</h2>
                            </div>
                            <div className="main">
                                {typeData && typeData.length ?
                                    <>
                                        <ul className="type-list">
                                            {typeData.map((items, index) => {
                                                return ((typeData.length > 6 && index > 4 && index < typeData.length - 1) ? null :
                                                    <li key={index} className={typeDataSelectIndex === index ? 'active' : ''} onClick={() => setTypeDataSelectIndex(index)}>
                                                        <span>{items.name}</span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                        <ul className="data-list">
                                            {typeData[typeDataSelectIndex].data && typeData[typeDataSelectIndex].data.length && typeData[typeDataSelectIndex].data.map((items, index) => {
                                                return (
                                                    <li key={index}>
                                                        <div className="list-item">
                                                            <img className="item-img" onError={(e) => imgError(e)} src={items.houseTypeImg ? `${items.houseTypeImg}?x-oss-process=style/acommon` : require("../../../images/common/detail-default.png")} />
                                                            <div className="item-content-flex item-content">
                                                                <p className="title ellipsis">{items.title}</p>
                                                                {items.tags && items.tags.length ?
                                                                    <p className="tags">
                                                                        {items.tags.map((it) => {
                                                                            return (<span key={it}>{it}</span>);
                                                                        })}
                                                                    </p> : null}
                                                            </div>
                                                            <div className="item-content-flex item-content">
                                                                <p className="area">{items.areaStr || ''}</p>
                                                            </div>
                                                            <div className="item-content-flex item-content">
                                                                <p className="price">{items.price || '价格待定'}</p>
                                                            </div>
                                                            <div className="item-content">
                                                                <p className="count">{items.count + '套'}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </> : <Nothing pagetype="detail" />}
                            </div>
                        </div>
                    </div>
                </div>
                <Message visible={messageInfo.visible} txt={messageInfo.txt} closeMessage={closeMessage} />
            </> : null) : <Nothing pagetype={pageCode} />}
        </>
    );
}

const mapState = state => {
    return {
        userInfo: state.user.userInfo
    };
};

export default connect(mapState)(Detail);
